import React from 'react';
import RouteMapItems from '../RouteMapItems/RouteMapItems';
import { useSingleTaskFieldRoutes } from './hooks/useSingleTaskFieldRoutes';

type Props = {};

const SingleTaskFieldRoutes: React.FC<Props> = () => {
  const { visibleRoutes, onFieldClick } = useSingleTaskFieldRoutes();

  return <RouteMapItems routes={visibleRoutes} onFieldClick={onFieldClick} />;
};

export default SingleTaskFieldRoutes;
